import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { Record } from "appworks/model/gameplay/records/record";
import { Services } from "appworks/services/services";
import { Exit } from "appworks/state-machine/data/exit";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { Contract } from "appworks/utils/contracts/contract";
import { Parallel } from "appworks/utils/contracts/parallel";
import { Timer } from "appworks/utils/timer";
import { JurisdictionComponent } from "slotworks/components/jurisdiction/jurisdiction-component";
import { AutoplayService } from "slotworks/services/autoplay/autoplay-service";
import { DelayState } from "./delay-state";

export class AutoplayDelayState extends DelayState {
    public onEnter() {
        uiFlags.set(UIFlag.IDLE, false);
        uiFlags.set(UIFlag.GAME_IN_PROGRESS, true);
        this.complete();
    }

    public complete(): void {
        const record: Record = gameState.getCurrentGame().getCurrentRecord();
        let delay: number = (record.sumWins <= 0) ? this.wait : 0;

        if(uiFlags.has(UIFlag.BIG_WIN_DELAY)) {
            delay += uiFlags.SLAM_STOP_DELAY;
        }
        
        if (Components.get(JurisdictionComponent)) {
            new Parallel([
                () => Components.get(JurisdictionComponent)?.waitForMinSpin(),
                () => Contract.getTimeoutContract(delay)
            ]).then(() => {
                if (!Services.get(AutoplayService).isAutoPlaying()) {
                    this.cancelGroup.cancel();
                    this.stateMachine.changeState(Exit.Error, this);
                } else {
                    super.complete();
                }
            });
        } else {
            Timer.setTimeout(() => {
                if (!Services.get(AutoplayService).isAutoPlaying()) {
                    this.cancelGroup.cancel();
                    this.stateMachine.changeState(Exit.Error, this);
                } else {
                    super.complete();
                }
            }, delay);
        }
    }
}
